'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.BidderRemote = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _helpers = require('./helpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var transformRequest = function transformRequest(details) {
    var transformed = {
        addr1: details.address1,
        addr2: details.address2,
        city: details.city,
        country: details.country,
        fname: details.firstName,
        lname: details.lastName,
        phone: details.mobile,
        postal_code: details.zipcode,
        sms_phone: details.mobile,
        state: details.state,
        username: details.username
    };

    if (details.email) {
        transformed.email_address = details.email;
    }
    return transformed;
};

var transform = function transform(details) {
    var bidder = details.bidder,
        auth_tokens = details.auth_tokens,
        token = details.token,
        success = details.success;
    var address = bidder.address,
        address2 = bidder.address2,
        bidder_id = bidder.bidder_id,
        city = bidder.city,
        country = bidder.country,
        join_date = bidder.join_date,
        email = bidder.email,
        firstName = bidder.firstName,
        lastName = bidder.lastName,
        mobileNumber = bidder.mobileNumber,
        phoneNumber = bidder.phoneNumber,
        standing = bidder.standing,
        state = bidder.state,
        username = bidder.username,
        zip = bidder.zip,
        profile_complete = bidder.profile_complete;


    return {
        bidder: {
            address: address,
            address2: address2,
            bidderId: bidder_id,
            city: city,
            country: country,
            createdDate: join_date,
            creditCardValidated: false,
            email: email,
            firstName: firstName,
            lastName: lastName,
            mobileNumber: mobileNumber,
            phoneNumber: phoneNumber,
            profileComplete: !!profile_complete,
            standing: standing,
            state: state,
            username: username,
            zip: zip
        },
        mainhostLogin: auth_tokens,
        success: success,
        token: token
    };
    /* eslint-enable */
};

var BidderRemote = exports.BidderRemote = {
    fetchBidderData: function fetchBidderData(_ref) {
        var authToken = _ref.authToken,
            deployment = _ref.deployment;
        return new _promise2.default(function (resolve, reject) {
            var request = (0, _helpers.makeGet)('<ITEM-API>auth/spauser', deployment);
            (0, _helpers.addAuthToken)(request, authToken);
            request.end(function (err, response) {
                return (0, _helpers.handleResponse)({ err: err, reject: reject, resolve: resolve, response: response });
            });
        });
    },
    postCompleteAccount: function postCompleteAccount(_ref2) {
        var authToken = _ref2.authToken,
            bidderDetails = _ref2.bidderDetails,
            deployment = _ref2.deployment;
        return new _promise2.default(function (resolve, reject) {
            var request = (0, _helpers.makePost)('<MAINHOST-API>api/u_bidr', deployment);
            (0, _helpers.addAuthToken)(request, authToken);
            request.query({ client_version: '4.3' });
            request.type('form');
            if (bidderDetails) {
                // why is there an if?
                request.send(transformRequest(bidderDetails));
            }
            request.end(function (err, response) {
                return (0, _helpers.handleResponse)({ err: err, reject: reject, resolve: resolve, response: response, transform: transform });
            });
        });
    },
    postCreateAccount: function postCreateAccount(_ref3) {
        var deployment = _ref3.deployment,
            emailAddress = _ref3.emailAddress;
        return new _promise2.default(function (resolve, reject) {
            var request = (0, _helpers.makePost)('<USER-API>', deployment, 'createuser');
            request.send({
                client_version: '4.3',
                email_address: emailAddress,
                signup_client: 'web'
            });
            request.end(function (err, response) {
                return (0, _helpers.handleResponse)({ err: err, reject: reject, resolve: resolve, response: response });
            });
        });
    },
    postLogin: function postLogin(_ref4) {
        var deployment = _ref4.deployment,
            mainhostLogin = _ref4.mainhostLogin,
            password = _ref4.password,
            username = _ref4.username;
        return new _promise2.default(function (resolve, reject) {
            var request = (0, _helpers.makePost)('<ITEM-API>auth/spalogin', deployment);
            request.type('form');
            request.send((0, _extends3.default)({ password: password, username: username }, mainhostLogin));
            request.end(function (err, response) {
                return (0, _helpers.handleResponse)({ err: err, reject: reject, resolve: resolve, response: response });
            });
        });
    },
    postSetPassword: function postSetPassword(_ref5) {
        var authToken = _ref5.authToken,
            deployment = _ref5.deployment,
            password = _ref5.password;
        return new _promise2.default(function (resolve, reject) {
            var request = (0, _helpers.makePost)('<USER-API>', deployment, 'createpassword');
            (0, _helpers.addAuthToken)(request, authToken);
            request.send({ password: password });
            request.end(function (err, response) {
                return (0, _helpers.handleResponse)({ err: err, reject: reject, resolve: resolve, response: response });
            });
        });
    },
    postSetSearchFacetOptionExclusion: function postSetSearchFacetOptionExclusion(_ref6) {
        var authToken = _ref6.authToken,
            deployment = _ref6.deployment,
            exclude = _ref6.exclude,
            facetId = _ref6.facetId,
            optionId = _ref6.optionId;
        return new _promise2.default(function (resolve, reject) {
            var requestURL = void 0;
            // transform the `exclude` bool into a number (0 or 1)
            var excludeBit = ~~exclude;

            switch (facetId) {
                case 'auctionHouse':
                    requestURL = '<ITEM-API>search/exclusion/seller/' + optionId + '/' + excludeBit;
                    break;
                default:
                    return reject('Excluding search results by ' + facetId + ' is not yet supported.');
            }
            var request = (0, _helpers.makePost)(requestURL, deployment);

            (0, _helpers.addAuthToken)(request, authToken);
            request.send();
            request.end(function (err, response) {
                return (0, _helpers.handleResponse)({ err: err, reject: reject, resolve: resolve, response: response });
            });
        });
    }
};


//////////////////
// WEBPACK FOOTER
// ./src/redux/api/remote/bidder.js
// module id = bSWU
// module chunks = 57